module.exports = "/assets/5999645eab32972ce1ab7c5e857ebaaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/supplier/assets/logos/premier-inn.png
// module id = 607
// module chunks = 0